<template>
	<el-drawer size="800px" :show-close="false" :visible="active" :before-close="closeDlg">
		<template slot="title">
			<div class="el-drawer-close" @click="closeDlg"><i class="el-icon el-icon-arrow-left"></i>返回</div>
			<el-button class="el-drawer-save" type="primary" size="mini" :loading="isLoading" @click="saveForm" v-if="!disabled">保存</el-button>
			{{item.name}}
		</template>
		<div class="drawer-content qst-form2">
			<el-form ref="form" size="small" label-position="left" label-width="120px" :disabled="disabled" :model="form">
				<div class="item" style="padding: 0;">
					<div>尊敬的病友：</div>
					<div>当您出院时，医院全体员工真诚祝愿您和您的家人身体健康，万事如意！</div>
					<div>您的满意是我们医院永远的追求，为了更好地服务于广大群众，进一步改善服务态度，提升服务质量，请对我院的服务进行评价，以便不断改进我们的工作和服务，谢谢您的支持！</div>
				</div>
				<div class="item">
					<div class="qst">1. 您对病房环境是否满意？（安静、整洁）</div>
					<div class="opts">
						<el-radio-group v-model="form.q1">
							<el-radio :label="4">非常满意</el-radio>
							<el-radio :label="3">满意</el-radio>
							<el-radio :label="2">一般</el-radio>
							<el-radio :label="1">不满意</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="item">
					<div class="qst">2. 您对病房设施（电视、空调、热水等）提供的服务是否满意？</div>
					<div class="opts">
						<el-radio-group v-model="form.q2">
							<el-radio :label="4">非常满意</el-radio>
							<el-radio :label="3">满意</el-radio>
							<el-radio :label="2">一般</el-radio>
							<el-radio :label="1">不满意</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="item">
					<div class="qst">3. 入院时，护士是否向您介绍住院须知，医护人员及相关生活设施的使用方法、各项安全及治疗中注意事项等是否满意？</div>
					<div class="opts">
						<el-radio-group v-model="form.q3">
							<el-radio :label="4">非常满意</el-radio>
							<el-radio :label="3">满意</el-radio>
							<el-radio :label="2">一般</el-radio>
							<el-radio :label="1">不满意</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="item">
					<div class="qst">4. 您对护士的服务态度是否满意？</div>
					<div class="opts">
						<el-radio-group v-model="form.q4">
							<el-radio :label="4">非常满意</el-radio>
							<el-radio :label="3">满意</el-radio>
							<el-radio :label="2">一般</el-radio>
							<el-radio :label="1">不满意</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="item">
					<div class="qst">5. 您对护士的操作技术的熟练度是否满意？</div>
					<div class="opts">
						<el-radio-group v-model="form.q5">
							<el-radio :label="4">非常满意</el-radio>
							<el-radio :label="3">满意</el-radio>
							<el-radio :label="2">一般</el-radio>
							<el-radio :label="1">不满意</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="item">
					<div class="qst">6. 您对医生的服务态度是否满意？</div>
					<div class="opts">
						<el-radio-group v-model="form.q6">
							<el-radio :label="4">非常满意</el-radio>
							<el-radio :label="3">满意</el-radio>
							<el-radio :label="2">一般</el-radio>
							<el-radio :label="1">不满意</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="item">
					<div class="qst">7. 您对主管医师告知情况  （介绍病情、检查结果、治疗方案、大额费用等）是否满意？</div>
					<div class="opts">
						<el-radio-group v-model="form.q7">
							<el-radio :label="4">非常满意</el-radio>
							<el-radio :label="3">满意</el-radio>
							<el-radio :label="2">一般</el-radio>
							<el-radio :label="1">不满意</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="item">
					<div class="qst">8. 您对主管医生治疗过程及出院指导是否满意？</div>
					<div class="opts">
						<el-radio-group v-model="form.q8">
							<el-radio :label="4">非常满意</el-radio>
							<el-radio :label="3">满意</el-radio>
							<el-radio :label="2">一般</el-radio>
							<el-radio :label="1">不满意</el-radio>
						</el-radio-group>
					</div>
				</div>
			</el-form>
			
		</div>
	</el-drawer>
</template>

<script>
import api from '@/service/api.js';
import mixin from '@/views/mixin';

export default {
	mixins: [mixin],
	props: {item: {required: true}, disabled: {required: true}},
	data(){
		return {
			noSidebar: true,
			active: false,
			form: {dictId: 0, q1: '', q2: '', q3: '', q4: '', q5: '', q6: '', q7: '', q8: ''},
			patientId: 0
		}
	},
	created() {this.init();},
	methods: {
		async init() {
			if (this.item.resultJson && this.item.resultJson.length > 0) {
				this.form = JSON.parse(this.item.resultJson);
			}			
			this.$nextTick(async ()=>{
				this.form.dictId = this.item.dictId;
				this.active = true;
				this.patientId = +this.$route.query.patientId;
			});
		},
		closeDlg() {
			this.$emit('close');
		},
		async saveForm() {
			let form  = this.form;
			if (form.q1 === '' || form.q2 === '' || form.q3 === '' || form.q4 === '' || form.q5 === '' || form.q6 === '' || form.q7 === '' || form.q8 === '') {
				return this.$message.warning('请完整填写问卷内容');
			}
			this.isLoading = true;
			let res = await api.submitSatisfactionQuestionnaire({id: this.item.id, patientId: this.patientId, resultJson: JSON.stringify(this.form)});
			this.isLoading = false;
			if (res.code != 1000) {return this.$message.error(res.message);}
			this.$message.success('保存成功');
			this.$emit('update', this.form);
		},
	}
}
</script>

<style lang="less" scoped>
@import './template.less';	
</style>
